export const FETCH_START = "EP/FETCH_START";

export interface FetchStartAction {
    readonly type: typeof FETCH_START;
}

export const fetchStart = (): FetchStartAction => ({
    type: FETCH_START,
});
